




import store from '../../store'
import Livestock from '../../components/Livestock.vue'

export default {
  data () {
    return {
      title: 'Livestock Sheep'
    }
  },

  components: {
    Livestock
  },

  store
}
